var map = {
	"./copper-anim/copper0.gif": "4f10",
	"./copper-anim/copper1.gif": "2ce4",
	"./copper-anim/copper10.gif": "7533",
	"./copper-anim/copper11.gif": "c5f6",
	"./copper-anim/copper12.gif": "d8d4",
	"./copper-anim/copper13.gif": "3d01",
	"./copper-anim/copper14.gif": "0d5f",
	"./copper-anim/copper15.gif": "5974",
	"./copper-anim/copper16.gif": "4bd6",
	"./copper-anim/copper2.gif": "e659",
	"./copper-anim/copper3.gif": "0c2f",
	"./copper-anim/copper4.gif": "0a53",
	"./copper-anim/copper5.gif": "2eff",
	"./copper-anim/copper6.gif": "bfc9",
	"./copper-anim/copper7.gif": "6a33",
	"./copper-anim/copper8.gif": "f56d",
	"./copper-anim/copper9.gif": "093a",
	"./copper_back.png": "e21f",
	"./copper_normal.png": "7132",
	"./copper_shiny.gif": "ec8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6992";